export const textBooleanHandler = (val: any) => {
    return val === 'true' ? false : true
}